/* eslint-disable @tanstack/query/exhaustive-deps -- doesn't work with the key factory*/
import { useQuery } from "@tanstack/react-query";

import { useCurrentTill } from "~/api/tills/hooks/use-till-current";

import { getUser } from "../request";
import { usersKeys } from "../keys";

type GetUserArgs =
  | {
      childId: string | null;
      childHex?: never;
    }
  | {
      childHex: string | null;
      childId?: never;
    };

export function useUser({ childId, childHex }: GetUserArgs) {
  const { data: till } = useCurrentTill();
  const tillId = till?.id;
  const isCollectTill = till?.type === "collect";

  return useQuery({
    queryKey: usersKeys.detail({
      childId: childId ?? null,
      childHex: childHex ?? null
    }),
    queryFn: async () => {
      if (!tillId) throw new Error("Till ID is required");

      if (!childId && !childHex) {
        throw new Error("Child ID or Child Hex is required");
      }

      return await getUser(tillId, {
        userChildId: childId ?? undefined,
        userChildHex: childHex ?? undefined,
        include: isCollectTill ? ["collectLimit"] : undefined
      });
    },
    enabled: Boolean(tillId) && Boolean(childId || childHex),
    // Refresh to catch externally-mutated balance (e.g. parent top-up).
    ...(isCollectTill && {
      staleTime: 0,
      refetchInterval: 1000 * 30
    })
  });
}
